$(document).ready(function () {
    var form = $('form[data-wffm]');

    var pageHeader = $('div.page-header', form);

    pageHeader.removeClass('page-header');

    $(pageHeader).replaceWith(function () {
        return $(this).html().replace('h1>', 'h3>');
    });

    $(document).on("tap click", 'form[data-wffm] label a', function (event, data) {
        event.stopPropagation();
        event.preventDefault();
        window.open($(this).attr('href'), $(this).attr('target'));
        return false;
    });
});